// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';



  const firebaseConfig = {
  apiKey: "AIzaSyA0xeK7QFFqhWxEkq6uoyZQ-hg2y0OCN70",
  authDomain: "mushroom-5d299.firebaseapp.com",
  projectId: "mushroom-5d299",
  storageBucket: "mushroom-5d299.firebasestorage.app",
  messagingSenderId: "248673643267",
  appId: "1:248673643267:web:fcab41fd3f95f23c165736",
  measurementId: "G-8REZ9GE39H"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth=getAuth(app);

export const messaging = getMessaging(app);

export default app;